var LoginForm = function () {

    this.init = function () {

        $('[data-component="login-form"] .scrollbar-inner').scrollbar();

        $('#loginFormValidate').validate({
            ignore: '.ignore',
            errorPlacement: function () {
                return true;
            },
            rules: {
                email: {
                    required: true,
                    email: true
                },
                password: {
                    required: true,
                    minlength: 5
                }
            },
            submitHandler: function (form) {

                var submittedForm = $(form);
                var componentID = parseInt(submittedForm.data("id"));

                submittedForm.find("button[type='submit']").attr("disabled", true);

                var loginData = {
                    "Email": submittedForm.find("input[name='email']").val(),
                    "Password": submittedForm.find("input[name='pass']").val()
                };

                $.ajax({
                    type: "POST",
                    url: "/umbraco/surface/members/login",
                    data: JSON.stringify(loginData),
                    dataType: "json",
                    async: true,
                    contentType: "application/json; charset=utf-8",
                    success: function success(response) {

                        if(response == true){
                            $("#loginFormValidate").each(function () {
                                this.reset();
							});
							$('#modal-header').find('#isMemberLogged').val("true");
                            
                            $("#modal-header").find(".close-modal").click();
							if($('#BlogPrivado').length > 0 && $('#BlogPrivado').val() == "true"){
								location.reload();
							}
                        }
                        else if(response == false){
                            $("#login-form").find(".error").text("Ocorreu um erro, tente novamente mais tarde");
                        }else if(response.length > 0){
                            $("#login-form").find(".error").text(response);
                        }

                    },
                    error: function error(e) {
                        $("#login-form").find(".error").text("Ocorreu um erro, tente novamente mais tarde");
                    },
                    complete: function () {
                        submittedForm.find("button[type='submit']").attr("disabled", false);
                    }
                });
            }
        });
    }

    return this.init();
}